import { CaretDown, CaretUp } from '@liveauctioneers/hammer-ui-core/icons';
import { H5 } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { ReactElement, ReactNode, useEffect, useState } from 'react';
import { Collapse } from 'react-collapse';

type Props = {
    children: ReactNode;
    className?: string;
    closeFacet?: boolean;
    header?: ReactNode;
    hideExpandCollapse?: boolean;
    hideTitle?: boolean;
    testid?: string;
    title: ReactNode;
};

export const Facet = ({
    children,
    className = '',
    closeFacet = false,
    header,
    hideExpandCollapse = false,
    hideTitle = false,
    testid,
    title,
}: Props): ReactElement<Props> => {
    const [isClosed, setIsClosed] = useState(closeFacet);

    useEffect(() => {
        setIsClosed(closeFacet);
    }, [closeFacet]);

    const handleClick = () => {
        setIsClosed(!isClosed);
    };

    return (
        <section
            className={cn(
                // Facet box
                'border-t border-border-secondary pb-sm pt-0',
                // last filter element
                '[&:last-child]:border-b [&:last-child]:border-border-secondary',
                className
            )}
            data-testid={testid}
        >
            {!hideTitle && !hideExpandCollapse && (
                <div
                    className="-mb-sm flex cursor-pointer items-center justify-between py-sm pl-0 pr-2xs"
                    data-testid={testid + 'Title'}
                    onClick={handleClick}
                >
                    {!hideTitle && (
                        <H5
                            className="select-none text-text-secondary"
                            color="secondary"
                        >
                            {title}
                        </H5>
                    )}
                    {!hideExpandCollapse && (
                        <>
                            {isClosed ? (
                                <CaretDown
                                    size="xs"
                                    style="fill"
                                />
                            ) : (
                                <CaretUp
                                    size="xs"
                                    style="fill"
                                />
                            )}
                        </>
                    )}
                </div>
            )}
            <Collapse isOpened={!isClosed}>
                <div className="mb-0 pt-sm">
                    {header}
                    {children}
                </div>
            </Collapse>
        </section>
    );
};
